/*
 * CarouselWrapper is a wrapper that that evaluates the user's reduce motion preference
 * to determine whether or not to animate the slide.
 * Currently uses Nuka Carousel's component.
 *
 */

import Carousel from 'nuka-carousel'
import PropTypes from 'prop-types'
import React from 'react'

import CustomPropTypes from '../customPropTypes'

import usePrefersReducedMotion from '../hooks/usePrefersReducedMotion'

const CarouselWrapper = ({children, ...rest}) => {
  const prefersReducedMotion = usePrefersReducedMotion()

  return (
    <Carousel disableAnimation={prefersReducedMotion} {...rest}>
      {children}
    </Carousel>
  )
}

CarouselWrapper.propTypes = {
  children: CustomPropTypes.children,
  disableAnimation: PropTypes.bool,
}

export default CarouselWrapper
